import { Component } from '@angular/core';

@Component({
    selector: 'ebb-v2-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class SignUpAppComponent {
  title = 'ebb-signup';
}
